import React, { FC, useContext } from 'react';
import { SafeAreaView, StatusBar, View } from 'react-native';
import styled, { css } from '@emotion/native';
import { LinearGradient } from 'expo-linear-gradient';

import { StatusModal } from '@components/2-molecules';

import setTheme from '@lib/theme';

import { STATE, APIData } from '@lib/constants';
import { useKeyboard } from '@lib/hooks/base/useKeyboardHeight';

const GradiantContainer = styled(LinearGradient)`
  height:  100%;
  min-height: 100%;
  position: relative;
  background-color: ${({ theme }: any) => `${theme.white}`};
`;

const ScrollView = styled.ScrollView``;

const Content = styled.View<{ keyboardHeight?: number; }>`
  align-items: center;
  width: ${({ noPadding }: any) => noPadding ? `100%` : `${theme.contentWidth}px`};

  ${(props) => props?.keyboardHeight && `
    padding-bottom: ${props?.keyboardHeight}px;
  `}
`;

const theme = setTheme('light');

const TemplateAuth: FC<Props> = ({ children, style, hooks, gradiant = theme.gradients.primary, ...props }) => {

  const keyboardHeight = useKeyboard();

  const scrollViewRef = React.useRef(null);
  React.useEffect(() => {
    // @ts-ignore
    scrollViewRef.current?.scrollTo({ x: 0, y: keyboardHeight, animated: true });
  }, [keyboardHeight]);

  return (
    <SafeAreaView style={{ flex: 1 }}>
      <GradiantContainer style={style} theme={theme} {...gradiant}>
        <StatusBar backgroundColor={"#000000"} barStyle={'light-content'} />

        <ScrollView
          ref={scrollViewRef}
          style={{ flex: 1 }}
          contentContainerStyle={{ flexGrow: 1, justifyContent: 'center' }}
        >
          <Content keyboardHeight={keyboardHeight} {...props}>
            {children}
          </Content>
        </ScrollView>

      </GradiantContainer>

      {
        hooks?.map((hook: APIData, index: number) => {
          return <StatusModal {...hook} key={index} />;
        })
      }

    </SafeAreaView>
  );
};

type Props = {
  noPadding?: boolean;
  children: React.ReactNode;
  style?: object;
  gradiant?: any;
  hooks?: Array<APIData>;
};

export default TemplateAuth;